<template>
  <div>    
    <MainNavBar />
    <Hero :hero="heroFiles" />  
    <GmxFooter /> 
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import GmxFooter from '@/components/footer.vue';

export default {
  name: 'Files',
  components: {
    MainNavBar,
    Hero,
    GmxFooter,
  },
  data() {
    return { 
      heroFiles: { 
        eyebrow: 'Productivity and Building Lifecycle Solid Server and Apps',
        header: 'TrinApp\u2122 Files',
        subheader: 'Lorem ipsum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        img: 'test.png',
        //videoId: 699342008,
        buttons: [
          { label: 'Click here', uri: '' }
        ]
      }
    }
  }
};
</script>

